import React from "react";
import CustomToolTip from "../../../../../../../CommonComponents/CustomToolTip";
import { PlayPauseSvg } from "../../../../../../../CommonComponents/timeline/Svg";

// Sync button component
interface SyncButtonProps {
  isSynced: boolean;
  onToggle: () => void;
}

const SyncButton: React.FC<SyncButtonProps> = ({ isSynced, onToggle }) => (
  <CustomToolTip
    title={isSynced ? "Unsync from replay" : "Sync to replay"}
    placement="left"
  >
    <button
      className={`thm-pb-btn thm-pb-sync${isSynced ? " active" : ""}`}
      onClick={onToggle}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" fill="none">
        <circle cx="4" cy="4" r="4" fill="currentColor" />
      </svg>
    </button>
  </CustomToolTip>
);

// Playback controls group (play + speed)
interface PlaybackControlsProps {
  isPlaying: boolean;
  isLastStep: boolean;
  playbackSpeed: number;
  isSynced: boolean;
  onTogglePlay: () => void;
  onCycleSpeed: () => void;
}

const PlaybackControls: React.FC<PlaybackControlsProps> = ({
  isPlaying,
  isLastStep,
  playbackSpeed,
  isSynced,
  onTogglePlay,
  onCycleSpeed,
}) => (
  <div className="thm-pb-play-speed-group">
    <CustomToolTip
      title={isPlaying ? "Pause" : isLastStep ? "Replay" : "Play"}
      placement="left"
    >
      <button
        className="thm-pb-btn thm-pb-play"
        disabled={isSynced}
        onClick={onTogglePlay}
      >
        <PlayPauseSvg state={isPlaying ? "play" : "pause"} />
      </button>
    </CustomToolTip>
    <CustomToolTip title="Cycle playback speed" placement="left">
      <button
        className="thm-pb-btn thm-pb-speed"
        disabled={isSynced}
        onClick={onCycleSpeed}
      >
        {playbackSpeed}×
      </button>
    </CustomToolTip>
  </div>
);

export interface ThermalControlsBarProps {
  isPlaying: boolean;
  isLastStep: boolean;
  playbackSpeed: number;
  isSynced: boolean;
  onToggleSync: () => void;
  onTogglePlay: () => void;
  onCycleSpeed: () => void;
}

export const ThermalControlsBar: React.FC<ThermalControlsBarProps> = ({
  isPlaying,
  isLastStep,
  playbackSpeed,
  isSynced,
  onToggleSync,
  onTogglePlay,
  onCycleSpeed,
}) => {
  return (
    <div className="thm-3d-playback-col">
      <SyncButton isSynced={isSynced} onToggle={onToggleSync} />
      <PlaybackControls
        isPlaying={isPlaying}
        isLastStep={isLastStep}
        playbackSpeed={playbackSpeed}
        isSynced={isSynced}
        onTogglePlay={onTogglePlay}
        onCycleSpeed={onCycleSpeed}
      />
    </div>
  );
};

export interface ThermalControlsLayoutProps {
  isFullscreen: boolean;
  controls: React.ReactNode;
  rowClassName?: string;
  contentClassName?: string;
  children: React.ReactNode;
}

export const ThermalControlsLayout: React.FC<ThermalControlsLayoutProps> = ({
  isFullscreen,
  controls,
  rowClassName = "thm-chart-main-row",
  contentClassName = "thm-chart-left",
  children,
}) =>
  isFullscreen ? (
    <div className={rowClassName}>
      <div className={contentClassName}>{children}</div>
      {controls}
    </div>
  ) : (
    <div className={rowClassName}>
      <div className={contentClassName}>
        {controls}
        {children}
      </div>
    </div>
  );
